"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAdvertisementSelection = void 0;
var player_base_1 = require("@24i/player-base");
function applyAdvertisementSelection(selection, options) {
    if (options.length === 0)
        return null;
    switch (selection) {
        case player_base_1.AdvertisementSelection.ALL:
            return options[0];
        case player_base_1.AdvertisementSelection.LAST:
            return options[options.length - 1];
        case player_base_1.AdvertisementSelection.NONE:
        default:
            return undefined;
    }
}
exports.applyAdvertisementSelection = applyAdvertisementSelection;
//# sourceMappingURL=applyAdvertisementSelection.js.map